var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-chip',{staticClass:"text-overline"},[_c('v-icon',{attrs:{"left":""}},[_vm._v(" mdi-clock ")]),_c('span',{key:`span-${_vm.key}`},[_vm._v(" "+_vm._s(_vm._f("duration2format")(_vm.date,_vm.format))+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }